document.addEventListener("DOMContentLoaded", () => {
    let searchInputElement = document.getElementById("country_search");

    if (searchInputElement.value.length > 0) {
        search(searchInputElement.value);
    }

    searchInputElement.addEventListener("input", e => search(e.target.value));
});

function search(value) {
    if (typeof value === "string") {
        value = value.toLowerCase();
    }

    if (value.length === 0 || !value) {
        document.querySelectorAll(".country-item")
            .forEach(element => {
                element.classList.remove("hidden");
                element.classList.add("block");
            });
    } else {
        document.querySelectorAll(".country-item")
            .forEach(element => {
                if (element.dataset.searchable.includes(value)) {
                    element.classList.remove("hidden");
                    element.classList.add("block");
                } else {
                    element.classList.remove("block");
                    element.classList.add("hidden");
                }
            });
    }
}
